














import {
  defineNuxtComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CPostcodeAutocomplete from '~/components/shared/configurable/form/autocomplete/CPostcodeAutocomplete.vue'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CFormGroup,
    CPostcodeAutocomplete
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const facet = ref(props.modelValue)

    const postcode = ref({
      name: facet.value?.values?.selected?.postcode || ''
    })

    watch(
      () => props.modelValue,
      newValue => {
        facet.value = {
          ...facet.value,
          ...newValue
        }

        postcode.value = {
          name: facet.value?.values?.selected?.postcode || ''
        }
      }
    )

    function handlePostcodeChange(newValue: any) {
      emit('update:modelValue', {
        name: facet.value.urlargNames[1],
        value: newValue.name
      })
    }

    function handlePostcodeUpdate(newValue: any) {
      if (!newValue.name) {
        postcode.value = {
          name: ''
        }

        emit('update:modelValue', {
          name: facet.value.urlargNames[1],
          value: ''
        })
      }
    }

    return {
      facet,
      postcode,
      handlePostcodeChange,
      handlePostcodeUpdate
    }
  },
  i18n: defineComponentTranslations({
    region: {
      en: 'Region',
      el: 'Περιοχή'
    },
    your_location: {
      en: 'Your location',
      el: 'Η περιοχή σου'
    }
  })
})
